export default "__VITE_ASSET__dd200969__"